import { COLORS, TYPOGRAPHY } from '../../../../styles/theme'

/**
 * Single source of truth for all survey insight chart colours.
 * Everything derives from the brand purple #6E53F9.
 */

// Brand primary — used for bars, stat badges, reference lines
export const INSIGHT_PRIMARY = COLORS.primary // #6E53F9
export const INSIGHT_PRIMARY_HOVER = COLORS.primaryHover // #8A72FA

// Cursor highlight on bar hover
export const INSIGHT_CURSOR_FILL = 'rgba(110, 83, 249, 0.08)'

// Yes/No — purple-family semantic pair: teal-purple for yes, muted purple for no
export const INSIGHT_COLOR_YES = '#7c3aed' // deep violet
export const INSIGHT_COLOR_NO = '#c4b5fd' // lavender

// Scale 1–5: dark → light purple ramp (low = deep, high = brand primary)
export const INSIGHT_SCALE_COLORS: [string, string, string, string, string] = [
  '#3b1fa8', // 1 — very deep indigo
  '#5438d4', // 2 — deep purple
  '#6E53F9', // 3 — brand primary
  '#8A72FA', // 4 — lighter brand
  '#b3a4fc', // 5 — lavender
]

// Shared tooltip style passed directly to Recharts <Tooltip>
export const INSIGHT_TOOLTIP_STYLE = {
  contentStyle: {
    fontSize: TYPOGRAPHY.caption.fontSize,
    borderRadius: 6,
    background: 'var(--color-bg-elevated)',
    color: 'var(--color-text-primary)',
    border: '1px solid var(--color-border)',
  },
  labelStyle: { color: 'var(--color-text-primary)' },
  itemStyle: { color: 'var(--color-text-primary)' },
} as const
